namespace GeniuzPOS.Product {
    export class ReportExportV1Columns {
        static columnsKey = 'Product.ReportExportV1';
    }
}
